
import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ColorModeContext, useMode } from "./theme";
import { ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import { SnackbarProvider } from "notistack";
import { useTranslation } from "react-i18next";
import { useMemo } from 'react'
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import RootRoute from "./Routes/RootRoute";
import DashRoutes from "./Routes/Routes";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalaali from "@date-io/jalaali";
import rtlPlugin from "stylis-plugin-rtl";
import AdapterMoment from "@date-io/moment";
import moment from "moment";
import "moment/locale/en-gb"; // یا هر locale انگلیسی که بخوای



import { DashboardSettingProvider } from "./Context/DashboardSettingProvider";
import { DashboardModalsProvider } from "./Context/DashboardModalsContext";
const queryClient = new QueryClient();
const cacheRtl = createCache({ key: "muirtl", stylisPlugins: [prefixer, rtlPlugin] });
const cacheLtr = createCache({ key: "muiltr", stylisPlugins: [prefixer] });


function App() {
document.documentElement.getAttribute('dir')

const [theme, colorMode] = useMode();
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  const cache = useMemo(
    () => (isRtl ? cacheRtl : cacheLtr),
    [isRtl]
  );

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider
          dateAdapter={isRtl ? AdapterJalaali : AdapterMoment}
          adapterLocale={isRtl ? "faIR" : "en"}
        >
          <ColorModeContext.Provider value={colorMode}>
            <CacheProvider value={cache}>  {/* ← ثابت نیست، داینامیکه */}
              <ThemeProvider theme={theme}>
              
                      <CssBaseline />
                      <RootRoute />
                      <DashRoutes />
                    
  
              </ThemeProvider>
            </CacheProvider>
          </ColorModeContext.Provider>
        </LocalizationProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
}

export default App;
